<template>
  <div class="taskList">
    <el-row :gutter="20">
      <el-col :span="14">
        <h1 class="title">云分享任务单</h1>
        <div class="condition">
          <el-form
            :model="taskListCondition"
            ref="taskListConditionForm">
            <!--任务单名称-->
            <div class="taskListCondition">
              <el-form-item class="taskListName" label="任务单名称：" label-width="130px">
                <el-input
                  size="small"
                  v-model="taskListCondition.TaskName"
                  placeholder="请输入名称"></el-input>
              </el-form-item>
              <el-form-item class="taskListBtns">
                <el-button size="small" type="primary" @click="searchTaskList">查询</el-button>
                <el-button size="small" @click="resetConditionForm">重置</el-button>
              </el-form-item>
            </div>
            <!--            省市学校-->
            <el-row class="taskListCondition" :gutter="15">
              <el-col :span="10">
                <el-form-item label="省-市-学校/单位：" label-width="130px">
                  <el-autocomplete
                    clearable
                    size="small"
                    v-model="selProvince"
                    class="inline-input"
                    :fetch-suggestions="fetchProvinceData"
                    placeholder="请输入省份名"
                    @select="selProvinceData"
                    @clear="clearProvinceData"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item>
                  <el-autocomplete
                  clearable
                    size="small"
                    v-model="selCity"
                    class="inline-input"
                    :fetch-suggestions="fetchCityData"
                    placeholder="请输入城市名"
                    @select="selCityData"
                     @clear="clearCityData"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item>
                  <el-autocomplete
                    clearable
                    size="small"
                    v-model="selSchool"
                    class="inline-input"
                    :fetch-suggestions="fetchSchoolData"
                    placeholder="请输入学校名称"
                    @select="selSchoolData"
                    @clear="clearSchoolData"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <el-table
          :highlight-current-row="true"
          ref="taskListTable"
          @cell-click="cellClick"
          header-row-class-name="tableHeader"
          :stripe="true"
          :border="false"
          height="550"
          style="width: 99.9%!important; "
          @sort-change="taskListTableColumnSort"
          :data="taskList">
          <!--          任务单名称-->
          <el-table-column
            prop="TaskName" width="200" align="left"
            label="任务单名称">
          </el-table-column>
          <el-table-column label="精品标记" width="100">
             <template slot-scope="scope">
               <el-tag v-if="scope.row.QualityMark == 1" size="small" type="info" effect="dark">精品</el-tag>
             </template>
           </el-table-column>
          <!--省市学校-->
          <el-table-column
            prop="SchoolName"
            sortable="custom"
            min-width="160"
            label="省-市-学校/单位">
          </el-table-column>
          <!--作者-->
          <el-table-column
            width="100"
            prop="TeacherName"
            label="作者">
          </el-table-column>
          <!--时间-->
          <el-table-column
            sortable="custom"
            width="160"
            prop="SharedTime"
            label="分享时间">
          </el-table-column>
          <!--状态-->
          <el-table-column
            sortable="custom"
            width="80"
            prop="ShowState"
            label="状态">
            <template slot-scope="scope">
              {{scope.row.ShowState}}
            </template>
          </el-table-column>
          <!--操作区-->
          <el-table-column
            width="160"
            fixed="right"
            label="操作">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.ShowState.trim()===store.state.qualityClassState.added.dis && scope.row.TeacherID != loginTeacherID"
                type="text" size="medium"
                @click="deleteTaskTeachingPlan(scope)">
                取消添加
              </el-button>
              <el-button
                v-if="scope.row.ShowState.trim()===store.state.qualityClassState.notAdded.dis"
                type="text" size="medium"
                @click="addTaskTeachingPlan(scope)">
                添加
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="taskListPaginationChange"
          :page-size="taskListPagination.pageSize"
          :pager-count="taskListPagination.pageCounter"
          layout="prev, pager, next,jumper"
          :total="taskListPagination.total">
        </el-pagination>
      </el-col>
      <el-col :span="10" class="rightVideo">
        <div class="rVideo" style="position: relative;">
          <h1 class="title">任务单题目列表</h1>
          <el-table
            ref="questionTable"
            :highlight-current-row="true"
            header-row-class-name="tableHeader"
            :stripe="true"
            :border="true"
            height="650"
            style="width: 99.9%!important;position: absolute; "
            :data="taskQuestions">
            <el-table-column
              width="60"
              prop="QuestionNum"
              label="题号">
            </el-table-column>
            <el-table-column
              width="60"
              prop="PageNum"
              label="页码">
            </el-table-column>
            <el-table-column
              :filters="questionTypesName"
              :filter-method="filterQuestionType"
              width="80"
              prop="QuestionTypeName"
              label="题型">
            </el-table-column>
            <el-table-column
              label="题目">
              <template slot-scope="scope">
                <img
                  style="width:90%;"
                  v-if="scope.row.QuestionStemImage!==''" :src="scope.row.QuestionStemImage"/>
                <div style="text-align: left;color:#000;" v-else v-html="scope.row.QuestionStem">
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "TaskAdd",
    //定义接收的属性
    props: {
      chapterId: [String, Number], // 章节ID
      TeachingPlanId: [String, Number], //课时ID
      taskType: { //类型, 1,添加任务单, 2任务单选题
        type: [String, Number],
        default: 1
      }
    },
    data() {
      return {
        /*任务单数据开始*/
        taskList: [],
        //任务单分页信息
        taskListPagination: {
          pageSize: 1,//每页多少行
          total: 0,//总行数
          pageCounter: 11,//折叠数,只能为单数....神奇啊
        },
        showTaskListVideo: false, //视频播放
        taskListVideo: {},//当前选择的视频. },
        //任务单搜索条件.
        //重置与第一次搜索时的条件
        taskListCondition: {
          CurrentPage: 1,//搜索第几页
          PageSize: 10,//每页多少行
          //ChapterID:this.ChapterID,
          ChapterID: this.chapterId,
          TeachingPlanID: this.TeachingPlanId,
          // CourseName: '',
          TaskName: '',
          ProvinceID: '',
          CityID: '',
          AreaID: '',
          SchoolID: '',
          //过滤的几个字段
          TeacherID: '',
          SourceType: '',//类型：0非精品、1精品、空全部.
          Sort: [
            {SortField: "SharedTime", SortType: "desc"}
          ]
        },
        provinceData: [],//省data
        selProvince: '',//当前选择的省份.
        cityData: [], //市data
        selCity: '', //当前选择的市.
        schoolData: [],
        selSchool: '',
        teacherFilters: [],//字段过滤作者
        stateFilters: [],///字段过滤  状态
        taskDetail: {},
        /*任务单数据结束*/
        loginTeacherID : localStorage["TeacherID"],

        taskQuestions: [],

        questionTypesName:[
          {
            "value": 1,
            "text": "单选题"
          },
          {
            "value": 2,
            "text": "多选题"
          },
          {
            "value": 3,
            "text": "判断题"
          },
          {
            "value": 4,
            "text": "填空题"
          },
          {
            "value": 5,
            "text": "主观题"
          }
        ],
      }
    },
    beforeUpdate(){
      this.$nextTick(() => { //在数据加载完，重新渲染表格
        this.$refs['questionTable'].doLayout();
      })
    },
    methods: {
      /*任务单相关 开始*/
      //获取字典
      getDist() {
        this.axios.post(window.url + "GetDicForQuestionTypeAndDifficultLvl").then(res => {
          //console.log("字典", res);
          //异常处理.
          if (res.data.result !== 200) {
            this.$message({
              message: res.data.message,
              type: 'error'
            });
            return;
          }
          //获取正常数据.
          //this.distDifficultLvls = res.data.data.DifficultLvls;
          this.questionTypesName = res.data.data.QuestionTypes



        })
      },
      // 获取任务单
      getTaskListAuditedBySearchPage() {
        this.axios.post(window.url + 'GetTaskListAuditedBySearchPage', this.taskListCondition)
          .then(res => {
            //console.log("任务单:", res);
            if (res.data.result == 200) {
              let resData = res.data.data;
              if (resData.Content.length == 0) {
                // this.$message({
                //   showClose: true,
                //   message: "未查到任务单",
                //   type: 'warning'
                // });
                this.taskList = [];
                return;
              }
              this.taskList = resData.Content;
              this.taskListPagination.total = resData.totalSize;
              this.taskListPagination.pageSize = resData.pageSize;
              this.getTaskForQuestionList(this.taskList[0].ID)
              this.$refs.taskListTable.setCurrentRow(this.taskList[0])
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch(error => {
            this.$message.error(error);
          })
      },
      //获取作者/专家/来源/状态的过滤数据
      /* getTaskFilterData() {
        this.axios.post(window.url + 'GetTaskListAuditedBySearchPage', this.taskListCondition)
          .then(res => {
            //console.log("专家数据", res);
            if (res.data.result == 200) {
              let resData = res.data.data;
              this.expertFilters = resData.expertFilters;
              this.sourceFilters = resData.sourceFilters;
              this.stateFilters = resData.stateFilters;
              this.teacherFilters = resData.teacherFilters;
            } else {
              this.$message({
                showClose: true,
                message: res.data.message,
                type: 'warning'
              });
            }
          }).catch(error => {
          this.$message({
            showClose: true,
            message: error,
            type: 'warning'
          });
        })
      }, */
      //分页显示
      taskListPaginationChange(e) {
        //console.log(e);
        this.taskListCondition.CurrentPage = +e;
        this.getTaskListAuditedBySearchPage();
      },
      //删除任务单
      deleteTaskTeachingPlan(scope) {
        //console.log(scope);
        let condition = {
          TeachingPlanID: this.TeachingPlanId,//备课信息id、
          TaskListID: scope.row.ID,//任务单id、
          // ChapterID: this.chapterId,//绑定的章节id
        }
        this.axios.post(window.url + 'DeleteTaskListTeachingPlan ', condition)
          .then(res => {
            //console.log("删除返回", res);
            if (res.data.result === 200) {
              this.$message.success('操作成功');
              this.getTaskListAuditedBySearchPage();
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch(error => {
            //异常
            this.$message.error('无响应,请稍后再试！');
          })
      },
      //添加任务单
      addTaskTeachingPlan(scope) {
        //console.log(scope);
        let condition = {
          TeachingPlanID: this.TeachingPlanId,//备课信息id、
          TaskListID: scope.row.ID,//任务单id、
          ChapterID: this.chapterId,//绑定的章节id
        }
        // console.log(condition);
        // return;
        this.axios.post(window.url + 'AddTaskListTeachingPlan', condition).then(
          res => {
            //console.log(res);
            if (res.data.data) {
              this.$message.success('操作成功');
              this.getTaskListAuditedBySearchPage();
            } else {
              this.$message.error(res.data.message);
            }
          }
        );
      },
      cellClick(row, column) {
        if (column.property == 'TaskName') {
          this.getTaskForQuestionList(row.ID)
        }
      },
      // 搜索任务单,单写是为了验证,备留
      searchTaskList() {
        this.$refs['taskListConditionForm'].validate((valid) => {
          if (valid) {
            this.getTaskListAuditedBySearchPage();
          } else {
            return false;
          }
        });
      },
      //搜索全部重置-
      resetConditionForm() {
        // console.log("调用了吗");
        // this.$refs['taskListConditionForm'].resetFields();
        this.taskListCondition = {
          CurrentPage: 1,//搜索第几页
          PageSize: 10,//每页多少行
          //ChapterID:this.ChapterID,
          ChapterID: this.chapterId,
          TeachingPlanID: this.TeachingPlanId,
          TaskName: '',
          ProvinceID: '',
          CityID: '',
          AreaID: '',
          SchoolID: '',
          SourceType: '',
          TeacherID: '',
          Sort: [
            {SortField: "AddTime", SortType: "desc"}
          ],
        };
        this.selProvince = '';//省重置
        this.selCity = '';//市重置
        this.selSchool = '';//学校重置
        //过滤器重置
        this.$refs.taskListTable.clearFilter();
        this.getTaskListAuditedBySearchPage();
      },
      //列排序
      taskListTableColumnSort(column, prop, order) {
        switch (column.prop) {
          case "SchoolName":
            this.taskListCondition.Sort[0].SortField = "SchoolID";
            break;
          case "SourceType":
            this.taskListCondition.Sort[0].SortField = "Source";
            break;
          case "ShowState":
            this.taskListCondition.Sort[0].SortField = "State";
            break;
          case "SharedTime":
            this.taskListCondition.Sort[0].SortField = "SharedTime";
            break;
        }
        this.taskListCondition.Sort[0].SortType = column.order == 'ascending' ? 'asc' : 'desc';
        this.getTaskListAuditedBySearchPage();
      },
      //作者,专家,来源,状态 过滤品
      /* taskListTableColumnFilter(value) {
        let tmpArr = value[Object.keys(value)[0]];
        this.taskListCondition[tmpArr[0]] = tmpArr.slice(1).join();
        this.getTaskListAuditedBySearchPage();
      }, */
      /*由原来根据条件筛选, 改为当页筛选*/
      /* taskListTableColumnFilter_SourceType(val,row,column){
        // console.log(val,row,column);
        if(val===1)   return row.SourceType==="自制";
        return  row.SourceType==="云精品"
      }, */
      taskListTableColumnFilter_ShowState(val,row,column){
        //console.log(val,row,column);
        if(val)   return row.ShowState==="已添加";
        return  row.ShowState==="未添加"
      },

      /*任务单相关 结束*/
      /* 省级开始  , 获取省列表 */
      getProvince(pid) {
        this.axios.post(window.url + 'GetListAreaLvl', {Pid: pid || -1})
          .then(
            res => {
              //console.log("省市份信息",res);
              if (res.data.result === 200) {
                //如果无值, 则为省份
                if (!pid) {
                  let provinceData = res.data.data;
                  // 数据过滤,改变属性名
                  provinceData.filter((val, i, arr) => {
                    val.value = val.CityName;
                    delete val.CityName;
                  });
                  this.provinceData = provinceData;
                } else { //有值则代表市级
                  //console.log("市级信息", res);
                  let cityData = res.data.data;
                  // 数据过滤,改变属性名
                  cityData.filter((val, i, arr) => {
                    val.value = val.CityName;
                    delete val.CityName;
                  });
                  this.cityData = cityData;
                }
              }
            }
          )
      },
      //省输入后的筛选,
      fetchProvinceData(queryStr, callBackFun) {
        //console.log(queryStr,callBackFun);
        // 数组过滤
        let provinceData = this.provinceData.filter((val) => {
          //判断val中是否有queryStr
          if (val.value.indexOf(queryStr) !== -1) {
            return val
          }
        });
        callBackFun(provinceData);
      },
      clearProvinceData() {
        this.taskListCondition.ProvinceID = '';
        this.selCity = '';
        this.selSchool = '';
        this.taskListCondition.CityID = '';
        this.taskListCondition.SchoolID = '';
        this.cityData = [];
        this.schoolData = [];
      },
      //省选择后的修改
      selProvinceData(item) {
        this.taskListCondition.ProvinceID = item.CityCode;
        this.getProvince(item.CityCode);
        this.selCity = '';
        this.selSchool = '';
        this.taskListCondition.CityID = '';
        this.taskListCondition.SchoolID = '';
      },
      /* 省级结束, 获取省列表 */


      /* 市级开始  , 获取市列表 */
      fetchCityData(queryStr, callBackFun) {
        //console.log(queryStr,callBackFun);
        // 数组过滤
        let cityData = this.cityData.filter((val) => {
          //判断val中是否有queryStr
          if (val.value.indexOf(queryStr) !== -1) {
            return val
          }
        });
        callBackFun(cityData);
        //console.log(provinceData);
      },
      clearCityData() {
        this.taskListCondition.CityID = '';
        this.selSchool = '';
        this.taskListCondition.SchoolID = '';
        this.schoolData = [];
      },
      selCityData(item) {
        //console.log(item);
        this.taskListCondition.CityID = item.CityCode;
        this.selSchool = '';
        this.taskListCondition.SchoolID = '';
        this.getSchoolListByArea(item.CityCode);
      },
      /* 市级开始  , 获取市列表 */

      /*学校选择开始*/
      // 获取学校列表
      getSchoolListByArea(Code) {
        this.axios.post(window.url + 'GetSchoolListByArea', {Code: Code})
          .then(
            res => {
              if (res.data.result === 200) {
                //如果无值, 则为省份
                let schoolData = res.data.data;
                // 数据过滤,改变属性名
                schoolData.filter((val, i, arr) => {
                  val.value = val.Name;
                  delete val.Name;
                });
                this.schoolData = schoolData;
              }
            })
      },
      fetchSchoolData(queryStr, callBackFun) {
        // 数组过滤
        let schoolData = this.schoolData.filter((val) => {
          //判断val中是否有queryStr
          if (val.value.indexOf(queryStr) !== -1) {
            return val
          }
        });
        callBackFun(schoolData);
      },
      clearSchoolData() {
        this.taskListCondition.SchoolID = '';
      },
      selSchoolData(item) {
        this.taskListCondition.SchoolID = item.Id;
      },
      /*学校选择结束*/

      //任务单详情开始
      getTaskForQuestionList(TaskListID) {
        this.axios.post(window.url + 'GetTaskForQuestionList', {TaskListID})
          .then(res => {
            //console.log("有值吗", res);
            //异常处理.
            if (res.data.result !== 200) {
              this.$message.error({
                message: res.data.message,
              });
              return;
            }
            //获取正常数据.
            this.taskQuestions = res.data.data;
          })
      },
      filterQuestionType(value, row, column){
        //console.log(value, row, column);
        return value === row.QuestionType;
      }
      // 任务单详情结束

    },
    mounted() {
      //console.log("父级",this.$parent);
      this.getProvince();//获取省份信息.
      this.getTaskListAuditedBySearchPage();
      // this.getTaskFilterData();//获取过滤数据.
      //this.getDist();


    }
  }
</script>

<style lang="less" scoped>
  .taskList {
    height: 100%;

    .el-row {
      height: 100%;

      .el-col {
        height: 100%;
      }
    }

    h1.title {
      background: #409EFF;
      color: #fff;
      height: 50px;
      font-size: 32px;
      font-weight: bold;
      line-height: 50px;
      margin-bottom: 22px;
    }

    /*搜索条件开始*/

    .condition {
      margin-bottom: 10px;

      .taskListCondition {
        display: flex;

        .el-form-item {
          margin-bottom: 6px;
        }

        .taskListName {
          flex: 1 1 auto;
          margin-right: 12px;
        }

        .taskListBtns {
          width: 160px;
          text-align: right;
        }

        .el-autocomplete {
          display: block;
        }
      }
    }


    /*搜索条件结束*/

    /deep/ .el-tabs__header {
      .el-tabs__item {
        font-size: 20px;
      }
    }

    .el-table {
      margin-bottom: 10px;
      width: 99.9%!important;

      /deep/ td, th {
        padding: 5px 0;
      }

      /deep/ .el-table__row {

      }
      /*.cell{
        height:20px!important;
      }*/
    }

    /deep/ .tableHeader {
      background: #F6F6F6;


      th {
        background: #F6F6F6;
        color: #2c3e50;

        .cell.highlight {
          /*background: #F6F6F6;*/
          color: #2c3e50;
        }
      }
    }
/*
    /deep/ .el-table__header {
      overflow: hidden;
      width: 99.9%!important;
      table-layout: unset;
      border-collapse: collapse;
    }*/
    /deep/ .el-table__body {
      /*overflow: hidden;
      width: 99.9%!important;*/
      tbody {
        tr {
          td:first-child:hover {
            /*text-decoration: underline;*/
            cursor: pointer;
            color: #409EFF;
          }
        }
      }
    }

    .rightVideo {
      position: relative;

      .rVideo {
        .title {
          background: #409EFF;
          color: #fff;
          height: 50px;
          font-size: 32px;
          font-weight: bold;
          line-height: 50px;
          margin-bottom: 22px;

        }

        .video {

          video {
            width: 100%;
          }
        }
      }
    }


  }
</style>



// WEBPACK FOOTER //
// src/components/detail/TaskAdd.vue